import styles from './curriculaNavBar.module.scss';

interface CurriculaNavBarProps {
    activeTab: string;
    volumeCount: number;
    templateCount: number;
    folderCount: number;
    setActiveTab: (tab: string) => void;
}


const CurriculaNavBar = ({ activeTab, setActiveTab, volumeCount, templateCount, folderCount }: CurriculaNavBarProps) => {
    const tabs = [
        { label: 'Volumes', count: volumeCount },
        { label: 'Templates', count: templateCount },
        { label: 'Folders', count: folderCount },
    ];

    return (
        <div className={styles.container}>
            <div className={styles.navButtons}>
                {tabs.map((tab, index) => {
                    const tabIndex = (index + 1).toString();
                    const navText = `${tab.label} (${tab.count})`;
                    return (
                        <div
                            key={tabIndex}
                            className={`${styles.navButton} ${activeTab === tabIndex ? styles.active : ''}`}
                            onClick={() => setActiveTab(tabIndex)}
                        >
                            {navText}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default CurriculaNavBar;